function productSlickCarousel() {
  $("#Slider-signup-page-desktop-products").slick({ 
      dots: false, 
      autoplay: false,
      pauseOnHover: false, 
      fade: false, 
      infinite: false, 
      arrows: true, 
      slidesToShow: 3, 
      slidesToScroll: 1, 
      easing: "ease", 
      vertical: false,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="" aria-disabled="false"><!--<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="transparent"></path></svg>--></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><!--<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="transparent"></path></svg>--></button>'
  });
}

var smsFormRequest;

$(document).on('submit', '#sms-only-form', function(e) {

  

  e.preventDefault();

  var $form = $("#sms-only-form");

  if (smsFormRequest) {
    smsFormRequest.abort();
  }

  var $countryCode = $form.find(".iti__selected-dial-code").text(),
      $enteredNumber = $form.find("#newsletterPhoneNumber").val().toLowerCase(),
      $combinedNumber = $countryCode + $enteredNumber,
      $phone_number = $combinedNumber.trim();


  var attentiveData = {
  user: {
      phone: "" + $phone_number + "",
  },
  signUpSourceId: "" + window.signupPageData.attentiveID + "",
  };

  let fetchContent = false;

  if ($form.hasClass('content-fetch-form')) {
    fetchContent = $form.attr('data-content-to-fetch');
  }


  if ($(".iti__flag").hasClass("iti__us")) {
    $.ajax({
        type: "POST", // define the type of HTTP verb we want to use (POST for our form)
        url: "https://krw-attve.herokuapp.com/attve-v2.php", // the url where we want to POST
        data: JSON.stringify(attentiveData), // our data object
        dataType: "json", // what type of data do we expect back from the server
        success: function(response){

          
          
            $(".form--step-1").addClass("form--hidden-step");
            $(".form--step-3").removeClass("form--hidden-step");

          
      
            setTimeout(function () {
              window.scrollTo({
                top: 0,
                behavior: 'smooth' // Smooth scroll to the top
              });
            }, 1000);
      
            // Update success images
            var successMobileImage = document.querySelector(".about--pillar-left img[data-success-mobile-image]");
            var successDesktopImage = document.querySelector(".about--pillar-left[data-success-desktop-image]");
            if (successMobileImage) {
              successMobileImage.src = successMobileImage.dataset.successMobileImage;
              $('.tooltip-on-image').css('display', 'block')
            }
            if (successDesktopImage) {
              successDesktopImage.style.backgroundImage = "url(" + successDesktopImage.dataset.successDesktopImage + ")";
            }

          

          
    
            setTimeout (function(){
                  $('.sale--products').fadeIn(300);
                  if ($(window).width() > 990) {
                    setTimeout(function() {
                      productSlickCarousel();
                    },100);
                  }
            }, 500);
          

        },
        error: function(response){
          console.log('error');
          console.log('Response: ' +response);
          
        }
    });
  }
  
});
